import { fetchEventSource } from '@microsoft/fetch-event-source'
import { processMsg, processError } from './process-msg'
import { safeParseJson } from '@/utils'
import { tokenKey } from '@/utils/user'
import storage, { storagekeys } from '@/utils/storage'
import { CacheUserInfo } from '@/business/login'
import { getStores } from '@/stores'

export interface ProxyRequestOpt {
  requestType?: 'sse' | 'http'
  body?: any
  url?: string
  renderToChatPanel?: boolean
  showLoading?: boolean
  onConnect?: () => void //连接成功
  onDisconnect?: () => void
  onError?: (err: any) => void //sse请求连接错误
  onBusinessError?: (data: { code: number; msg: string }) => void //业务自定义错误码处理
  onBiz?: (res: { code: number; message: string; data: any[] }) => void
  timeout?: number
  onData?: (data: any) => void
}

export const proxyRequest = async (opt: ProxyRequestOpt) => {
  const { requestType = 'sse' } = opt || {}
  //使用sse请求模式
  if (requestType === 'sse') {
    sseRequest({
      ...opt
    })
  }
}

const sseRequest = async (opt: ProxyRequestOpt) => {
  try {
    const { renderToChatPanel = true, url, showLoading = true } = opt || {}
    if (!url) return
    const controller = new AbortController()
    const signal = controller.signal
    const timeout = opt.timeout || 1000 * 60 * 5 // 添加超时处理 默认5分钟超时

    const timeoutId = setTimeout(() => {
      controller.abort()
      opt.onError?.(new Error('请求超时'))
      processError(new Error('请求超时'))
    }, timeout)

    const data = storage.get<CacheUserInfo>(storagekeys.userInfo)
    const token = data?.userInfo?.token || ''
    const userInfo = storage.get<CacheUserInfo>(storagekeys.userInfo)
    const { agentV2Store } = getStores()

    if (showLoading) {
      agentV2Store.chatLoadingState.loading = true
      agentV2Store.chatLoadingState.loadingText = ''
    }

    // if (agentV2Store.previewUserToken && agentV2Store.inIframePreview) {
    //   token = agentV2Store.previewUserToken
    // }
    const lang = storage.get(storagekeys.currentLang)

    const processSSEMsg = (eventData: any) => {
      const data = typeof eventData === 'string' ? safeParseJson(eventData) : eventData

      opt?.onData?.(data)
      processMsg(data, {
        controller: controller,
        onBusinessError: opt.onBusinessError,
        onBiz: opt.onBiz,
        onDisconnect: opt.onDisconnect,
        onConnect: opt.onConnect,
        renderToChatPanel: renderToChatPanel
      })
    }

    const win = window as any
    win.pushMsg = processSSEMsg

    await fetchEventSource(url, {
      method: 'POST',
      openWhenHidden: true,
      headers: {
        'Content-Type': 'application/json',
        [tokenKey]: token,
        LoginType: 'aigc',
        lang,
        companyexid: userInfo?.selectedCompanyInfo?.company_ex_id || '',
        sessionid: storage.get<string>(storagekeys.currentSessionId) || ''
      },
      signal,
      body: opt?.body ? JSON.stringify(opt?.body) : undefined,
      onopen(response) {
        if (response.ok && response.headers.get('content-type') === 'text/event-stream') {
          console.log('Connection established')
          return Promise.resolve()
        } else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
          opt.onError?.(new Error('Client-side error'))
          console.error('Client-side error', response.status)
          return Promise.reject(new Error('Client-side error'))
        }
        return Promise.reject(new Error('Server-side error'))
      },
      onmessage(event) {
        // 请求完成后清除超时计时器
        clearTimeout(timeoutId)
        processSSEMsg(event.data)
      },
      onerror(err) {
        // 请求完成后清除超时计时器
        clearTimeout(timeoutId)
        opt.onError?.(err)
        processError(err)
        throw new Error('Stop retrying due to error')
      },
      onclose() {
        opt?.onDisconnect?.()
      }
    })
  } catch (err) {
    console.error('Failed to connect:', err)
  }
}
